import React from 'react'
import SMSPanel from '../SMSPanel/SMSPanel'
import LogsPanel from './LogsPanel'

export default function InformationsTab ({ appointment, setAppointment, style = {} }) {
  return (
    <div style={{ ...style, display: 'flex', justifyContent: 'space-between' }} >
      <div style={{ width: '47%' }} ><LogsPanel logs={appointment.logs} date={appointment.begin_date} /></div>
      <div style={{ width: '47%' }} ><SMSPanel owner={appointment} ownerType="appointments" setOwner={setAppointment} /></div>
    </div>
  )
}
